import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  InputNumber,
  Select,
} from "antd";
import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router";
import useRequest from "../hooks/useRequest";
import { ToTopOutlined, ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import { useNavigate } from "react-router";
const { Option } = Select;
const Search = Input.Search;
const DownTown = () => {
  const { request } = useRequest();
  const history = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [project, setProject] = useState([]);
  const [location, setLocation] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsProject, setSelectedOptionsProject] = useState([]);
  const [selectedOptionsType, setSelectedOptionsType] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const { confirm } = Modal;
  const normalizeName = (value) => String(value || "").trim().toLowerCase();
  const propertyTypes = [
    { id: 1, name: "Apartment" },
    { id: 2, name: "Villa" },
    { id: 3, name: "Townhouse" },
    { id: 4, name: "Penthouse" },
    { id: 5, name: "Compound" },
    { id: 6, name: "Duplex" },
    { id: 7, name: "Full Floor" },
    { id: 8, name: "Half Floor" },
    { id: 9, name: "Whole Building" },
    { id: 10, name: "Bulk Rent Unit" },
    { id: 11, name: "Bungalow" },
    { id: 12, name: "Hotel & Hotel Apartment" }
  ];
  const handleEdit = (record) => {
    setCurrentRecord(record); // Set the selected record to edit
    setIsModalVisible(true); // Open the modal
  };

  const handleDelete = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want to delete record? </Button>,
        onOk() {
          deleteData(record)
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const deleteData = (record) => {
    setLoading(true);
    request({
      url: `/admin/downtown/delete-file/${record ? record._id : selectedRowKeys}`,
      method: 'delete',
      onSuccess: (data) => {
        console.log(data)
        setLoading(false);
        setRefresh((prev) => !prev)
        ShowToast(data.message, Severty.SUCCESS)


      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const columns = [
    {
      title: "File Name",
      dataIndex: "file_name",
      key: "file_name",
    },
    {
      title: "Location Name",
      dataIndex: "location",
      key: "location",
      render: (_, { locationData }) => {
        return <div>{locationData ? locationData.name : "--"}</div>;
      },
    },
    {
      title: "Project Name",
      dataIndex: "project_name",
      key: "project_name",
      render: (_, { projectData }) => {
        return <div>{projectData ? projectData.name : "--"}</div>;
      },
    },
    {
      title: "Type",
      dataIndex: "typeData",
      key: "typeData",
      render: (_, { typeData }) => {
        return <div>{typeData ? typeData.name : "--"}</div>;
      },
    },
    {
      title: "Tag",
      dataIndex: "tag",
      key: "tag",
      render: (_, { tag }) => {
        return <div>{tag ? tag : "--"}</div>;
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Total Data",
      dataIndex: "data",
      key: "data",
    },

    {
      title: "Upload date",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      fixed: "right",
      render: (_, record) => {
        return (
          <>
            <div className="cta_wrap">
              <a href={`/data-excel/refine/${record._id}`}>
                <Button title="View" className="tb-view">
                  <i class="fa fa-light fa-eye"></i>

                </Button>
              </a>
              <Button title="Edit" onClick={() => handleEdit(record)}>
                <i class="fa fa-light fa-pen"></i>
              </Button>
              <Button title="Delete" onClick={() => handleDelete(record)}>
                <i class="fa fa-light fa-trash"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  const resetSearchPagination = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleFileSearchChange = (e) => {
    const value = e?.target?.value ?? "";
    setSearchInput(value);
    if (!value.trim()) {
      setSearchText("");
      resetSearchPagination();
    }
  };

  const handleFileSearchSubmit = (value) => {
    const appliedSearch = String(value ?? searchInput ?? "").trim();
    setSearchInput(value ?? searchInput ?? "");
    setSearchLoading(true);
    setSearchText(appliedSearch);
    resetSearchPagination();
  };
  useEffect(() => {
    fetchProject();
    fetchTypeList();
    fetchCountries();
  }, []);

  useEffect(() => {
    fetchLocation(selectedCountry, selectedState, selectedCity);
  }, [selectedCountry, selectedState, selectedCity]);

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [
    refresh,
    searchText,
    selectedOptions,
    selectedOptionsProject,
    selectedOptionsType,
    selectedCountry,
    selectedState,
    selectedCity,
  ]);

  const fetchData = (pagination, filters) => {
    const hasGlobalSearch = Boolean(String(searchText ?? "").trim());
    const params = [
      `listType=list`,
      `page=${pagination ? pagination.current : 1}`,
      `limit=${10}`,
      `search=${encodeURIComponent(searchText ?? "")}`,
    ];

    if (!hasGlobalSearch) {
      params.push(`location=${selectedOptions}`);
      params.push(`project=${selectedOptionsProject}`);
      params.push(`type=${selectedOptionsType}`);
      if (selectedCountry) params.push(`country=${selectedCountry}`);
      if (selectedState) params.push(`state=${selectedState}`);
      if (selectedCity) params.push(`city=${selectedCity}`);
    }

    const url = `/admin/downtown/list?${params.join('&')}`;

    request({
      url: url,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setSearchLoading(false);
        // ShowToast(data.message, Severty.SUCCESS)
        const list = data.data?.list?.docs.map((item) => ({
          key: item._id,
          ...item,
        }));
        setList(list);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
        }));
      },
      onError: (error) => {
        setLoading(false);
        setSearchLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    console.log(pagination, filters);
    fetchData(pagination, filters);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleClick = () => {
    history("/new-page/refine", { state: selectedRowKeys });

  }

  const fetchProject = () => {
    request({
      url: `/common/project-list`,
      method: "GET",
      onSuccess: (data) => {
        setProject(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const fetchTypeList = () => {
    request({
      url: `/common/type-list`,
      method: "GET",
      onSuccess: (data) => {
        setTypeList(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchCountries = () => {
    request({
      url: `/common/country`,
      method: "GET",
      onSuccess: (data) => {
        setCountries(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchStates = (countryId) => {
    if (!countryId) {
      setStates([]);
      return;
    }
    request({
      url: `/common/state/${countryId}`,
      method: "GET",
      onSuccess: (data) => {
        setStates(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchCities = (stateId) => {
    if (!stateId) {
      setCities([]);
      return;
    }
    request({
      url: `/common/city/${stateId}`,
      method: "GET",
      onSuccess: (data) => {
        setCities(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    if (selectedCountry || !countries?.length) return;

    const defaultCountry = countries.find((item) => {
      const name = normalizeName(item?.name);
      return name === "uae" || name === "united arab emirates";
    });

    if (defaultCountry?.id) {
      setSelectedCountry(defaultCountry.id);
      fetchStates(defaultCountry.id);
    }
  }, [countries, selectedCountry]);

  useEffect(() => {
    if (selectedState || !states?.length) return;

    const defaultState = states.find(
      (item) => normalizeName(item?.name) === "dubai"
    );

    if (defaultState?.id) {
      setSelectedState(defaultState.id);
      fetchCities(defaultState.id);
    }
  }, [states, selectedState]);

  useEffect(() => {
    if (selectedCity || !cities?.length) return;

    const defaultCity = cities.find(
      (item) => normalizeName(item?.name) === "dubai"
    );

    if (defaultCity?.id) {
      setSelectedCity(defaultCity.id);
    }
  }, [cities, selectedCity]);

  const fetchLocation = (countryId, stateId, cityId) => {
    let url = `/common/location-list`;
    const params = [];

    if (countryId) params.push(`country=${countryId}`);
    if (stateId) params.push(`state=${stateId}`);
    if (cityId) params.push(`city=${cityId}`);

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    request({
      url: url,
      method: "GET",
      onSuccess: (data) => {
        setLocation(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const resetFilterPagination = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleChangeLocation = (selectedValues) => {
    setSelectedOptions(selectedValues || []);
    resetFilterPagination();
  };
  const handleChangeProject = (selectedValues) => {
    setSelectedOptionsProject(selectedValues || []);
    resetFilterPagination();
  };
  const handleChangeType = (selectedValues) => {
    setSelectedOptionsType(selectedValues || []);
    resetFilterPagination();
  };

  const handleChangeCountry = (value) => {
    setSelectedCountry(value);
    setSelectedState(null);
    setSelectedCity(null);
    setSelectedOptions([]);
    resetFilterPagination();
    if (value) {
      fetchStates(value);
    } else {
      setStates([]);
      setCities([]);
    }
  };

  const handleChangeState = (value) => {
    setSelectedState(value);
    setSelectedCity(null);
    setSelectedOptions([]);
    resetFilterPagination();
    if (value) {
      fetchCities(value);
    } else {
      setCities([]);
    }
  };

  const handleChangeCity = (value) => {
    setSelectedCity(value);
    setSelectedOptions([]);
    resetFilterPagination();
  };
  return (
    <Main>
      <div className="tabled">
        <Row>
          <Col xs="24" md={24} lg={24} xl={24}>
            <h4 style={{ marginBottom: 12, color: "#1f2937", fontWeight: 600 }}>
              File Management
            </h4>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              extra={
                <>
                  <Button>{`Total File : ${pagination?.total || 0}`}</Button>
                  <Search
                    className="searchbar-layout"
                    size="large"
                    allowClear
                    enterButton={
                      <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        loading={searchLoading}
                      />
                    }
                    value={searchInput}
                    onChange={handleFileSearchChange}
                    onSearch={handleFileSearchSubmit}
                  />
                  <a href={`/recycle-bin`}>
                    <Button title="Restore" className="tb-view">
                      <i class="fa fa-light fa-recycle"></i>

                    </Button>
                  </a>
                  {selectedRowKeys.length > 0 ? <Button onClick={() => handleClick()} title="View" className="tb-view">
                    <i class="fa fa-light fa-eye"></i>

                  </Button> : ''}
                  {selectedRowKeys.length > 0 ? <Button onClick={() => handleDelete()} title="Delete" className="tb-view">
                    <i class="fa fa-light fa-trash"></i>

                  </Button> : ''}
                  <div className="role-wrap">
                    <Select
                      placeholder="Select Country"
                      value={selectedCountry}
                      onChange={handleChangeCountry}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {countries && countries.length > 0
                        ? countries.map((item, index) => (
                          <Option key={item.id} value={item.id}>{item.name}</Option>
                        ))
                        : null}
                    </Select>
                  </div>
                  <div className="role-wrap">
                    <Select
                      placeholder="Select State"
                      value={selectedState}
                      onChange={handleChangeState}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      disabled={!selectedCountry}
                      filterOption={(input, option) =>
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {states && states.length > 0
                        ? states.map((item, index) => (
                          <Option key={item.id} value={item.id}>{item.name}</Option>
                        ))
                        : null}
                    </Select>
                  </div>
                  {/* City dropdown removed as requested to avoid redundant Dubai */}
                  <div className="role-wrap">
                    <Select
                      placeholder="Select Location"
                      mode="multiple"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      value={selectedOptions}
                      onChange={handleChangeLocation}
                      disabled={!selectedCountry}
                      filterOption={(input, option) =>
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {location && location.length > 0
                        ? location.map((item) => (
                          <Option key={item._id} value={item._id}>
                            {item.name}
                          </Option>
                        ))
                        : null}
                    </Select>
                  </div>
                  <div className="role-wrap">
                    <Select
                      placeholder="Select Project"
                      mode="multiple"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      value={selectedOptionsProject}
                      onChange={handleChangeProject}
                      filterOption={(input, option) =>
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {project && project.length > 0
                        ? project.map((item) => (
                          <Option key={item._id} value={item._id}>
                            {item.name}
                          </Option>
                        ))
                        : null}
                    </Select>
                  </div>
                  <div className="role-wrap">
                    <Select
                      placeholder="Select Type"
                      mode="multiple"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      value={selectedOptionsType}
                      onChange={handleChangeType}
                      filterOption={(input, option) =>
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {typeList && typeList.length > 0
                        ? typeList.map((item) => (
                          <Option key={item._id} value={item._id}>
                            {item.name}
                          </Option>
                        ))
                        : null}
                    </Select>
                  </div>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={pagination}
                  onChange={handleChange}
                  rowSelection={rowSelection}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {setIsModalVisible && (
        <EditForm
          show={isModalVisible}
          hide={() => {
            setCurrentRecord();
            setIsModalVisible(false);
          }}
          data={currentRecord}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </Main>
  );
};


const EditForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [project, setProject] = useState([]);
  const [location, setLocation] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const propertyTypes = [
    { id: 1, name: "Apartment" },
    { id: 2, name: "Villa" },
    { id: 3, name: "Townhouse" },
    { id: 4, name: "Penthouse" },
    { id: 5, name: "Compound" },
    { id: 6, name: "Duplex" },
    { id: 7, name: "Full Floor" },
    { id: 8, name: "Half Floor" },
    { id: 9, name: "Whole Building" },
    { id: 10, name: "Bulk Rent Unit" },
    { id: 11, name: "Bungalow" },
    { id: 12, name: "Hotel & Hotel Apartment" }
  ];
  useEffect(() => {
    fetchProject();
    fetchLocation();
    fetchTypeList();
  }, []);
  const fetchTypeList = () => {
    request({
      url: `/common/type-list`,
      method: "GET",
      onSuccess: (data) => {
        setTypeList(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const fetchProject = () => {
    request({
      url: `/common/project-list`,
      method: "GET",
      onSuccess: (data) => {
        setProject(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchLocation = (countryId, stateId, cityId) => {
    let url = `/common/location-list`;
    const params = [];

    if (countryId) params.push(`country=${countryId}`);
    if (stateId) params.push(`state=${stateId}`);
    if (cityId) params.push(`city=${cityId}`);

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    request({
      url: url,
      method: "GET",
      onSuccess: (data) => {
        setLocation(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };




  useEffect(() => {
    if (data) form.setFieldsValue({ ...data });
  }, [data]);



  const onCreate = (values) => {
    setLoading(true);
    request({
      url: data
        ? `/admin/downtown/edit-file-data/${data._id}`
        : `/admin/downtown/add-downtown`,
      method: data ? "PUT" : "POST",
      data: values,
      onSuccess: () => {
        setLoading(false);
        refresh();
        hide();
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Edit" : "Create"} location`}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Form.Item
          label="File Name"
          name="file_name"
          rules={[
            { required: true, message: "Please enter the file name!" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Select Location"
          name="location"
          rules={[{ required: true, message: "Please select a location!" }]}
        >
          <Select placeholder="Select Location" showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }>
            {location && location.map((loc) => (
              <Option key={loc._id} value={loc._id}>
                {loc.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Select Project"
          name="project_name"
          rules={[{ required: true, message: "Please select a project!" }]}
        >
          <Select placeholder="Select Project" showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }>
            {project.map((proj) => (
              <Option key={proj._id} value={proj._id}>
                {proj.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Select Type"
          name="type"
          rules={[{ required: true, message: "Please select a type!" }]}
        >
          <Select placeholder="Select Type" showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }>
            {typeList.map((loc) => (
              <Option key={loc._id} value={loc._id}>
                {loc.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Year" name="year">
          <Select placeholder="Select a year">
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Tag"
          name="tag"
        ><Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default DownTown;
